module.exports = __webpack_public_path__ + "assets/img/3.b3ad0e76.png";